<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <h1 class="is-size-3">{{lead.name}} <span @click="openLeadEntryModal"><fa-icon icon="edit"></fa-icon></span></h1>
      <p>Added on: {{formatDate(lead.addedOn)}}</p>
      <div class="box">
        <div class="columns">
          <table class="column table">
            <tr>
              <th>Contact:</th>
              <td>{{lead.contactName}}</td>
            </tr>
            <tr>
              <th>Address:</th>
              <td>{{lead.address}} {{lead.address2}}, {{lead.city}} {{lead.state}} {{lead.zip}}</td>
            </tr>
          </table>
          <table class="column table">
            <tr v-if="lead.phone">
              <th>Phone</th>
              <td>{{lead.phone}}</td>
            </tr>
            <tr v-if="lead.cell">
              <th>Cell:</th>
              <td>{{lead.cell}}</td>
            </tr>
            <tr v-if="lead.fax">
              <th>Fax:</th>
              <td>{{lead.fax}}</td>
            </tr>
            <tr  v-if="lead.email">
              <th>Email:</th>
              <td>{{lead.email}}</td>
            </tr>
          </table>
          <table class="column table">
            <tr v-if="lead.notes">
              <th>Notes:</th>
              <td>{{lead.notes}}</td>
            </tr>
          </table>
        </div>
      </div>
      <section class="columns">
        <div class="column">
          Engagements
          <table class="table is-bordered is-striped is-fullwidth">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tr v-for="engagement in lead.engagements" :key="engagement.engagement_id">
              <td>
                <router-link :to="{ name: 'leads-day', params: getEngagementDateParams(engagement.occurred_on) }">
                  {{engagement.occurred_on}}
                </router-link></td>
              <td>{{engagement.type}}</td>
              <td>{{engagement.notes}}</td>
            </tr>
          </table>
          <a class="button" @click="openEngagementEntryModal">Add Engagement</a>
        </div>
        <div class="column">
          Resources
          <table class="table is-bordered is-striped is-fullwidth">
            <thead>
              <tr>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tr v-for="resource in lead.resources" :key="resource.resource_id">
              <td>{{resource.resource}}</td>
              <td>{{resource.given_on}}</td>
            </tr>
          </table>
        </div>
      </section>
      <modal @done="closeEngagementEntryModal" :is-active="isEngagementModalOpen">
        <engagement-entry @done="closeEngagementEntryModal" @cancel="closeEngagementEntryModal" :year="year" :month="month" :day="day" :lead="leadId"></engagement-entry>
      </modal>
      <modal @done="closeLeadEntryModal" :is-active="isLeadModalOpen">
        <lead-entry @done="closeLeadEntryModal" @cancel="closeLeadEntryModal" :lead-data="this.lead"></lead-entry>
      </modal>
    </div>
  </div>
</template>


<script>
import EngagementEntry from '@/components/EngagementEntry.vue';
import LeadEntry from '@/components/LeadEntry.vue';
import Modal from '@/components/Modal.vue';
import moment from 'moment';
import { getLeadDetails } from '@/utils/api';

export default {
  async created() {
    const lead = await getLeadDetails(this.leadId);
    this.lead = lead;
  },
  components: {
    modal: Modal,
    'engagement-entry': EngagementEntry,
    'lead-entry': LeadEntry,
  },
  props: ['leadId'],
  data() {
    return {
      lead: {
        leadId: null,
        name: null,
        customerName: null,
        contactName: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        fax: null,
        cell: null,
        email: null,
        notes: '',
      },
      isLeadModalOpen: false,
      isEngagementModalOpen: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    openEngagementEntryModal() {
      this.isEngagementModalOpen = true;
    },
    async closeEngagementEntryModal() {
      this.isEngagementModalOpen = false;
      const lead = await getLeadDetails(this.leadId);
      this.lead = Object.assign({}, this.lead, lead);
    },
    openLeadEntryModal() {
      this.isLeadModalOpen = true;
    },
    closeLeadEntryModal(updatedData) {
      this.isLeadModalOpen = false;
      this.lead = Object.assign({}, this.lead, updatedData);
    },
    getEngagementDateParams(occurredOn) {
      const date = moment(occurredOn);
      return { year: date.year(), month: date.month() + 1, day: date.date() };
    },
  },
};
</script>

<style scoped>
.column.table td, .column.table th {
  border: none;
}
</style>
